import { toPlainText } from '~/utils/format'

export default class ContactConsent {
  // Shared so the component that renders the application TCPA field and the page that saves the
  // consent produce the same text.
  static readonly applicationTcpaPrefix = 'By checking this box,'

  static async use(
    prefix?: string | undefined,
    version?: string | undefined,
    name?: string | undefined
  ) {
    const { getContactConsentContent } = Cms.use()

    const { content } = await getContactConsentContent(name ?? 'tcpa_and_ptc', version ?? null)

    const consentText = computed(() => _trim(`${prefix ?? ''}&nbsp;${content.value?.text}`))

    return {
      consentText
    }
  }

  static async useExt(
    prefix?: string | undefined,
    version?: string | undefined,
    name?: string | undefined
  ) {
    const { getContactConsentContent } = Cms.use()

    const { content } = await getContactConsentContent(name ?? 'tcpa_ext', version ?? null)

    const consentTextExt = computed(() => _trim(`${prefix ?? ''}&nbsp;${content.value?.text}`))

    return {
      consentTextExt
    }
  }

  static async saveConsents(
    consents: string[],
    consentText: string | null | undefined,
    partner: string = 'healthpilot'
  ) {
    const profile = ProfileStore.use()
    const { track, identify } = Analytics.use()
    const { tagEvent } = SessionReplay.use()

    // Reporting wants the copy the user read, not the markup it was rendered from.
    const plainConsentText = toPlainText(consentText)

    const payloads = consents.map((c) => ({
      type: c,
      partner,
      profileId: profile.id!
    }))

    identify(profile.id!, {
      email: profile.emailAddress?.address,
      phone: profile.primaryContactPhone?.number,
      properties: {
        subscribe: true,
        consent: ['email', 'sms']
      }
    })

    await Promise.all(
      payloads.map(async (p) => {
        await profile.addDataConsent(p)
        track('TcpaConsent', {
          ...p,
          email: profile.emailAddress?.address,
          phone: profile.primaryContactPhone?.number,
          consentText: plainConsentText
        })
        tagEvent('TcpaConsent', p)
      })
    )
  }
}
